import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useDecisionAuth } from '../../hooks/useDecisionAuth';
import DecisionLayout from './Layout';
import DecisionLoginPage from './LoginPage';
import DashboardPage from './DashboardPage';
import ProductDecisionPage from './ProductDecisionPage';
import PortfolioPage from './PortfolioPage';
import ConfigPage from './ConfigPage';
import MacroPage from './MacroPage';
import AiSettingsPage from './AiSettingsPage';
import { DecisionPortfolioProvider } from './DecisionPortfolioContext';

export default function DecisionApp() {
  const { user, checking, refresh, logout } = useDecisionAuth();

  if (checking) {
    return (
      <div className="login-wrap">
        <p className="decision-muted">验证登录…</p>
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<DecisionLoginPage onSuccess={refresh} />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <DecisionPortfolioProvider>
      <Routes>
        <Route element={<DecisionLayout user={user} onLogout={logout} />}>
          <Route index element={<DashboardPage />} />
          <Route path="/product" element={<ProductDecisionPage />} />
          <Route path="/macro" element={<MacroPage user={user} />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/config" element={<ConfigPage user={user} />} />
          <Route path="/ai-settings" element={<AiSettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </DecisionPortfolioProvider>
  );
}
